<template>
    <div class="blog">
        <div class="container">
            <a v-for="page in orderedPages" class="blog-item" :href="page.pageslug">
                <span class="blog-image" :style="'background-image: url('+page.blockimage+')'"></span>
                <span class="blog-content">
                    <strong class="blog-title display-6">
                        {{ page.pagetitle }} 
                    </strong>
                    <span class="blog-description text-muted">
                        {{ page.pagetext }} 
                    </span>
                </span>
            </a>
            <item-adder @clicked="getPages()" v-if="!readonly" :websiteid="websiteid" :parentpageid="pageid" blockstyle="blog-item" placeholdertext="Naam van item" linktext="Item toevoegen"/>
            
            <modal v-if="showModal" @close="showModal = false" title="Delete block">
                <form @submit.prevent="removePage(pageid)">
                    <p>Weet je zeker dat je deze block wil verwijderen?</p>
                    <button class="button" type="submit">Ja, ik weet het zeker</button>
                </form>
            </modal>
        </div>
    </div>
</template>

<script>
import ItemAdder from '../app/ItemAdder.vue';
import Modal from '../modal/Modal.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    components: {
        ItemAdder,
        Modal
    },
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      }
    },
    data: function() {
        return{
            readonly: false,
            showModal: false,
            pages: {}
        }
    },
    methods: {
        getPages(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+this.pageid)
            .then(response => {
              console.log('pages loaded')
                this.pages = response.data.response
            })
        },
        removePage(id){
            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id)
            .then(response => {
                console.log(response)
                this.showModal = false
            })
        }
    },
    mounted(){
        this.getPages()
    }
}
</script>